<template>
  <router-view></router-view>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "Quikly",
      meta: (function () {
        if (process.env.VUE_APP_IS_DEMO == 0) {
          return [
            { charset: "utf-8" },
            {
              "http-equiv": "X-UA-Compatible",
              content: "IE=edge,chrome=1",
            },
            {
              name: "viewport",
              content:
                "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0",
            },
          ];
        }
        return [
          { charset: "utf-8" },
          {
            "http-equiv": "X-UA-Compatible",
            content: "IE=edge,chrome=1",
          },
          {
            name: "viewport",
            content:
              "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0",
          },
          {
            name: "keywords",
            content:
              "creative tim, updivision, html dashboard, laravel, vue, vuejs, json:api, json, api, html css dashboard laravel, vue argon dashboard laravel, vue argon dashboard laravel pro, vue argon dashboard, vue argon dashboard pro, argon admin, vue dashboard, vue dashboard pro, vue admin, web dashboard, bootstrap 4 dashboard laravel, bootstrap 4, css3 dashboard, bootstrap 4 admin laravel, argon dashboard bootstrap 4 laravel, frontend, responsive bootstrap 4 dashboard, argon dashboard, argon laravel bootstrap 4 dashboard",
          },
          {
            name: "description",
            content:
              "Want to build an API-powered Laravel app using Vue and Creative Tim`s signature design system, Argon?",
          },
          {
            itemprop: "name",
            content: "Vue Argon Dashboard PRO Laravel by Creative Tim & UPDIVISION",
          },
          {
            itemprop: "description",
            content:
              "Want to build an API-powered Laravel app using Vue and Creative Tim`s signature design system, Argon?",
          },
          {
            itemprop: "image",
            content:
              "https://s3.amazonaws.com/creativetim_bucket/products/353/original/opt_adp_vue_laravel_thumbnail.jpg",
          },
          {
            name: "twitter:card",
            content: "product",
          },
          {
            name: "twitter:site",
            content: "@creativetim",
          },
          {
            name: "twitter:title",
            content: "Vue Argon Dashboard PRO Laravel by Creative Tim & UPDIVISION",
          },
          {
            name: "twitter:description",
            content:
              "Want to build an API-powered Laravel app using Vue and Creative Tim`s signature design system, Argon?",
          },
          {
            name: "twitter:creator",
            content: "@creativetim",
          },
          {
            name: "twitter:image",
            content:
              "https://s3.amazonaws.com/creativetim_bucket/products/353/original/opt_adp_vue_laravel_thumbnail.jpg",
          },
          {
            name: "twitter:url",
            content: "https://www.creative-tim.com/live/vue-argon-dashboard-pro-laravel",
          },
          {
            property: "fb:app_id",
            content: "655968634437471",
          },
          {
            property: "og:title",
            content: "Vue Argon Dashboard PRO Laravel by Creative Tim & UPDIVISION",
          },
          {
            property: "og:type",
            content: "article",
          },
          {
            property: "og:url",
            content: "https://www.creative-tim.com/live/vue-argon-dashboard-pro-laravel",
          },
          {
            property: "og:image",
            content:
              "https://s3.amazonaws.com/creativetim_bucket/products/353/original/opt_adp_vue_laravel_thumbnail.jpg",
          },
          {
            property: "og:description",
            content:
              "Want to build an API-powered Laravel app using Vue and Creative Tim`s signature design system, Argon?",
          },
          {
            property: "og:site_name",
            content: "Creative Tim",
          },
        ];
      })(),

      link: [
        { rel: "icon", type: "image/png", href: "/favicon.png" },
        {
          rel: "stylesheet",
          href: "https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700",
        },
        {
          href: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/js/all.min.js",
          integrity:
            "sha512-rpLlll167T5LJHwp0waJCh3ZRf7pO6IT1+LZOhAyP6phAirwchClbTZV3iqL3BMrVxIYRbzGTpli4rfxsCK6Vw==",
          crossorigin: "anonymous",
          referrerpolicy: "no-referrer",
        },
        {
          rel: "stylesheet",
          href: "https://use.fontawesome.com/releases/v5.6.3/css/all.css",
          integrity:
            "sha384-UHRtZLI+pbxtHCWp1t77Bi1L4ZtiqrqD80Kn4Z8NTSRyMA2Fd33n5dQ8lWUE00s/",
          crossorigin: "anonymous",
        },
      ],

      script: (function () {
        if (process.env.VUE_APP_IS_DEMO == 1) {
          return [
            {
              hid: "gtm-script1",
              innerHTML: `
        (function (a, s, y, n, c, h, i, d, e) {
        s.className += " " + y;
        h.start = 1 * new Date();
        h.end = i = function() {
          s.className = s.className.replace(RegExp(" ?" + y), "");
        };
        (a[n] = a[n] || []).hide = h;
        setTimeout(function() {
          i();
          h.end = null;
        }, c);
        h.timeout = c;
      })(window, document.documentElement, "async-hide", "dataLayer", 4000, {
        "GTM-K9BGS8K": true
      });
        `,
              type: "text/javascript",
              charset: "utf-8",
            },
            {
              hid: "ga",
              innerHTML: `
             (function (i, s, o, g, r, a, m) {
            i["GoogleAnalyticsObject"] = r;
            (i[r] =
              i[r] ||
              function () {
                (i[r].q = i[r].q || []).push(arguments);
              }),
              (i[r].l = 1 * new Date());
            (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
          })(
            window,
            document,
            "script",
            "https://www.google-analytics.com/analytics.js",
            "ga"
          );
          ga("create", "UA-46172202-22", "auto", { allowLinker: true });
          ga("set", "anonymizeIp", true);
          ga("require", "GTM-K9BGS8K");
          ga("require", "displayfeatures");
          ga("require", "linker");
          ga("linker:autoLink", ["2checkout.com", "avangate.com"]);
              `,
              type: "text/javascript",
              charset: "utf-8",
            },

            {
              hid: "gtm-script2",
              innerHTML: `
             (function(w, d, s, l, i) {
              w[l] = w[l] || [];
              w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
              var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != "dataLayer" ? "&l=" + l : "";
              j.async = true;
              j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
              f.parentNode.insertBefore(j, f);
            })(window, document, "script", "dataLayer", "GTM-NKDMSK6");
              `,
              type: "text/javascript",
              charset: "utf-8",
            },
            {
              href:
                "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/js/all.min.js",
              integrity:
                "sha512-rpLlll167T5LJHwp0waJCh3ZRf7pO6IT1+LZOhAyP6phAirwchClbTZV3iqL3BMrVxIYRbzGTpli4rfxsCK6Vw==",
              crossorigin: "anonymous",
              referrerpolicy: "no-referrer",
            },
          ];
        }
      })(),
    };
  },
};
</script>

<style>
@font-face {
  font-family: "OpenSans";
  src: local("OpenSans"),
    url(./assets/css/Fonts/OpenSans-Regular/OpenSans-Regular-webfont.ttf)
      format("truetype");
}
@font-face {
  font-family: "OpenSans-Bold";
  src: local("OpenSans-Bold"),
    url(./assets/css/Fonts/OpenSans-Bold/OpenSans-Bold-webfont.ttf) format("truetype");
}
@font-face {
  font-family: "OpenSans-Semibold";
  src: local("OpenSans-Semibold"),
    url(./assets/css/Fonts/OpenSans-Semibold/OpenSans-Semibold-webfont.ttf)
      format("truetype");
}
@font-face {
  font-family: "OpenSans-Light";
  src: local("OpenSans-Light"),
    url(./assets/css/Fonts/OpenSans-Light/OpenSans-Light-webfont.ttf) format("truetype");
}
</style>
